import React from "react";
import { Col } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const SharedsafariCardSkeleton = ({ count }) => {
  return (
    <>
      {[...Array(count)].map((_, index) => (
        <Col className="mb-xl-2  mb-md-3 mb-4" key={index}>
            <div className="shareimg">
            <Skeleton height={178} />
          </div>
        <div className="sharesafri-card sharesafri-card-dummy" key={index}>
            {/* Safari & Seat Row */}
            <div className="pt-2">
              <div className="safari d-flex justify-content-between px-2">
                <div className="safarinum d-flex gap-2 align-items-center">
                  <Skeleton height={20} width={50} />
                  <Skeleton height={20} width={30} />
                </div>
                <div className="safarinum d-flex gap-2 align-items-center">
                  <Skeleton height={20} width={50} />
                  <Skeleton height={20} width={30} />
                </div>
              </div>
            </div>

            {/* Title & Organizer */}
            <div className="titleDate">
              <Skeleton height={20} width={`80%`} />
              <Skeleton height={16} width={`60%`} className="mt-1" />
            </div>

            {/* Footer Row */}
            <div className="footer_card row pb-2 px-2 align-items-center">
              <div className="col-6">
                <Skeleton
                  height={25}
                  width={25}
                  circle
                  containerClassName="users"
                />
              </div>
              <div className="col-6 text-center">
                <Skeleton height={30} width={100} borderRadius={8} />
              </div>
            </div>
        </div>
        </Col>
      ))}
    </>
  );
};

export default SharedsafariCardSkeleton;



// import React from "react";
// import { Col } from "react-bootstrap";
// import Skeleton from "react-loading-skeleton";
// import "react-loading-skeleton/dist/skeleton.css";

// const SharedsafariCardSkeleton = ({ count }) => {
//   return (
//     <>
//       {[...Array(count)].map((_, index) => (
//         <Col className="mb-xl-2  mb-md-3 mb-4" key={index}>
//             <div className="shareimg">
//             <Skeleton height={178} />
//           </div>
//         <div className="sharesafri-card sharesafri-card-dummy" key={index}>
//             {/* Safari & Seat Row */}
//             <div className="pt-2">
//               <div className="safari d-flex justify-content-between px-2">
//                 <div className="safarinum d-flex gap-2 align-items-center">
//                   <Skeleton height={20} width={50} />
//                   <Skeleton height={20} width={30} />
//                 </div>
//                 <div className="safarinum d-flex gap-2 align-items-center">
//                   <Skeleton height={20} width={50} />
//                   <Skeleton height={20} width={30} />
//                 </div>
//               </div>
//             </div>

//             {/* Title & Organizer */}
//             <div className="titleDate mt-2 px-2">
//               <Skeleton height={20} width={`80%`} />
//               <Skeleton height={16} width={`60%`} className="mt-1" />
//             </div>

//             {/* Footer Row */}
//             <div className="footer_card row pb-2 px-2 align-items-center mt-2">
//               <div className="col-6">
//                 <Skeleton
//                   height={25}
//                   width={25}
//                   circle
//                   containerClassName="users"
//                 />
//               </div>
//               <div className="col-6 text-center">
//                 <Skeleton height={30} width={100} borderRadius={8} />
//               </div>
//             </div>
//         </div>
//         </Col>
//       ))}
//     </>
//   );
// };

// export default SharedsafariCardSkeleton;
